<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="35rem"
    persistent
  >
    <template v-slot:activator="{ on: dialog }">
      <v-list-item v-if="list" v-on="{ ...dialog }">
        <v-list-item-icon>
          <div class="plus-minus">
            <v-icon small>fa-plus</v-icon>
            <v-icon small>fa-minus</v-icon>
          </div>
          <v-icon>fa-mitten</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Production
        </v-list-item-title>
      </v-list-item>
      <v-btn
        color="success"
        v-else-if="helper === true"
        block
        v-on="{ ...dialog }"
      >
        <div class="plus-minus">
          <v-icon x-small>fa-plus</v-icon>
          <v-icon x-small>fa-minus</v-icon>
        </div>
        <v-icon small left>fa-mitten</v-icon>
        Production
      </v-btn>
      <v-btn
        color="accent"
        elevation="0"
        v-else
        :class="{
          'mr-1': !$vuetify.breakpoint.xsOnly
        }"
        :block="$vuetify.breakpoint.xsOnly"
        v-on="{ ...dialog }"
      >
        <div class="plus-minus">
          <v-icon x-small>fa-plus</v-icon>
          <v-icon x-small>fa-minus</v-icon>
        </div>
        <v-icon small left>fa-mitten</v-icon>
        Production
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-row align="center">
            <v-col cols="6">
              <v-btn
                :text="!add"
                :color="add ? 'success' : ''"
                block
                @click="add = true"
              >
                <v-icon small left>fa-plus</v-icon>
                Ajouter
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                :text="add"
                :color="add === false ? 'error' : ''"
                block
                @click="add = false"
              >
                <v-icon small left>fa-minus</v-icon>
                Retirer
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-autocomplete
              :items="
                getProducts.filter(
                  x => x.est_intermediaire === true && x.is_deleted === false
                )
              "
              item-value="id"
              item-text="nom"
              required
              :rules="[
                v => v !== undefined || 'Veuillez sélectionner un produit',
                v => v !== null || 'Veuillez sélectionner un produit'
              ]"
              v-model="data.id"
              filled
              class="no-before"
              label="Recette"
            ></v-autocomplete>
          </v-row>
          <v-row no-gutters>
            <j-decimal-input
              class="no-before"
              filled
              :min="0.0001"
              v-model="data.quantity"
              required
              :suffix="getProductUnit"
              label="Quantité"
            ></j-decimal-input>
          </v-row>
        </v-form>
        <v-progress-linear
          indeterminate
          color="primary"
          v-show="loading"
        ></v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :outlined="$vuetify.breakpoint.xsOnly"
            :text="!$vuetify.breakpoint.xsOnly"
            @click="dialog = false"
            :disabled="loading"
          >
            Annuler
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
            color="success"
            :disabled="!valid || loading"
            @click="save"
          >
            Appliquer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "ProductionDialog",
  props: {
    list: {
      type: Boolean,
      default: false
    },
    helper: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getIsAdmin"]),
    getProductUnit() {
      if (this.data.id) {
        return this.getProducts.find(x => x.id === this.data.id).data
          .unite_mesure_inventory;
      }
      return "";
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      valid: false,
      add: true,
      data: {
        id: undefined,
        quantity: 0
      }
    };
  },
  methods: {
    async save() {
      if (this.valid) {
        try {
          this.loading = true;
          const data = {
            ...this.data
          };
          if (this.add === false) {
            data.quantity = -1 * this.data.quantity;
          }
          await api.postProduction(data);
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          });
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    dialog(v) {
      this.add = true;
      if (v === false) {
        this.$refs.form.reset();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.plus-minus {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 0.5em;
  * {
    font-size: 0.5rem !important;
  }
}
</style>
